import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from 'src/app/services/APIService';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { MessagesService } from 'src/app/services/messages.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { AuctionService } from 'src/app/services/auction.service';
import 'devextreme/integration/jquery';
import { ConstantsModule } from 'src/app/services/constants.module';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { saveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import jsPDF from 'jspdf';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-aste-vinte',
    templateUrl: './aste-vinte.component.html',
    styleUrls: ['./aste-vinte.component.css'],
    standalone: false
})
export class AsteVinteComponent extends APIService implements OnInit, OnDestroy {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  constructor(public localService: LocalUtilService,
    public auctionService: AuctionService,
    private modalService: NgbModal,
    private messageService: MessagesService,
    location: Location, 
    router: Router, translateService: TranslateService) {
    super(localService, location, router, translateService);

  }

  auctions_list: any[]=[];  
  allMode: string;
  checkBoxesMode: string;
  private subscriptions: Subscription[] = [];

  ngOnInit(): void {
    console.log('init()');
    this.loadAuctions();
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();  // Prevents default scroll on space
    }
  }

  loadAuctions() {

    const listService = this.auctionService.listaAsteVinte("Chiusa").subscribe(
      (data:any) => { 
        this.auctions_list = data.list;
    });
    this.subscriptions.push(listService);
  }

  onRowPrepared(info) {
    if(info.rowType === 'data') {  
      info.rowElement.addClass('auction');  
    }
  }

  onContentReady(event) {
    this.listReport();
  }

  listReport() {
    
    if (this.auctions_list != undefined) {
        this.auctions_list.forEach(item => {
          const reportService = this.auctionService.getAuctionReportWon(item.codiceAsta).subscribe(
            data => {
              item.uuid = data.uuid
          });
          this.subscriptions.push(reportService);
        });
    }
  }

  openDettaglio(e) {
    console.log('event.target: ' + e.event.target.className);
    let className = e.event.target.className;
    if(e.rowType === "data" && className.toLowerCase().indexOf('pdf') < 0) {
      this.router.navigate([ConstantsModule.REF_AZ_ASTE_VINTE_DETTAGLIO_PATH + e.data.codiceAsta, {}]);
      //event.component.editRow(e.rowIndex);
    }
  }

  onExporting(e: DxDataGridTypes.ExportingEvent) {
    if (e.format === 'xlsx') {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(e.fileName);
      
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), e.fileName + '.xlsx');
        });
      });
    } else if (e.format === 'csv') {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(e.fileName);
      exportDataGrid({
          component: e.component,
          worksheet: worksheet
      }).then(function() {
          workbook.csv.writeBuffer().then(function(buffer) {
              saveAs(new Blob([buffer], { type: 'application/octet-stream' }), e.fileName + '.csv');
          });
      });
    } else  if (e.format === 'pdf') {
      const doc = new jsPDF();
      exportDataGridToPdf({
          jsPDFDocument: doc,
          component: e.component
      }).then(() => {
          doc.save(e.fileName + '.pdf');
      })
    }
  }

  ngOnDestroy() {
    try {
      this.subscriptions.forEach(sub => {
                
        sub.unsubscribe()
      });
    } catch (err) {
      //
    }
  }
}
